module.exports = __webpack_public_path__ + "static/media/success.af726e2a.svg";